import { forwardRef, useImperativeHandle, useLayoutEffect, useRef } from "react";

export const CellInput = forwardRef(function CellInput({ value, ...props }, ref) {
    const inputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        focus(options) {
            inputRef.current?.setSelectionRange(value.length, value.length);
            inputRef.current?.focus(options);
        },
    }));

    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.style.height = "1px";
            inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
        }
    }, [value]);

    return <textarea {...props} ref={inputRef} value={value} />;
});
